import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ContainerRefDirective } from '@common/directives';
import { CommonService } from 'src/app/common.service';
import { PopupService } from 'src/app/common/services/popup/popup.service';
import { DialogService } from 'src/app/fpx-core/services/dialog/dialog.service';

@Component({
  selector: 'app-service-request-info',
  templateUrl: './service-request-info.component.html',
  styleUrls: ['./service-request-info.component.scss']
})
export class ServiceRequestInfoComponent implements OnInit {
  @ViewChild(ContainerRefDirective, {static: true}) containerRef!: ContainerRefDirective;

  popupItem: any;

  constructor(@Inject(MAT_DIALOG_DATA) protected data: any,
  private dialogRef: MatDialogRef<ServiceRequestInfoComponent>,
  protected _commonService: CommonService,
  private _dialogService: DialogService) { }

  ngOnInit(): void {
    let component = this._dialogService.getPopup(this.data.requestType);
    this.popupItem = component;
  }

  ngAfterViewInit(){
    this.loadComponent();
  }

  loadComponent() {
    const popup = this.popupItem;

    const viewContainerRef = this.containerRef.viewContainerRef;
    viewContainerRef.clear();

    const componentRef = viewContainerRef.createComponent<any>(popup.component);
    componentRef.instance.data = this.data;
    if(this.data.embadedFormMode && this.data.routingKey) {
      componentRef.instance.embadedFormMode = this.data.embadedFormMode;
      componentRef.instance.routingKey = this.data.routingKey;
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }

}
